module.exports = __webpack_public_path__ + "img/定制服务.7968c611.png";